import {useOpenedStateManager} from '@aboutyou/opened-state-manager';
export enum SizeSelectionOpenedStateKey {
  MAIN_SIZE_SELECTION = 'size-selection',
  SHOP_THE_LOOK_SIZE_SELECTION = 'shop-the-look-size-selection',
  BASKET_FLYOUT_SIZE_SELECTION = 'basket-flyout-size-selection',
  OUTFIT_RECO_SIZE_SELECTION = 'outfit-reco-size-selection',
  COUPON_WALLET_SIZE_SELECTION = 'coupon-wallet-size-selection',
  NO_SIZE_SELECTED_SELECTION = 'no-size-selected-selection',
}

export const useSizeSelectionOpenedState = (
  key: SizeSelectionOpenedStateKey | string,
) => {
  return useOpenedStateManager(key);
};
